module.exports = __webpack_public_path__ + "static/media/paysafecard.0db2bc55.svg";